import { publishReplay, refCount, switchMap } from 'rxjs/operators';
import axios from 'axios';
import { activeDepartment$ } from './activeDepartment$';

export const left$ = activeDepartment$.pipe(
  switchMap(_ => axios.get('Nav/Left').then(response => response.data)),
  publishReplay(1),
  refCount()
);
